import { createContext, useContext } from 'react';
import { Lang, Strings } from './strings';

export type I18nCtx = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: Strings;
  /** Locale-aware 1-decimal number (3.5 in EN, 3,5 in FI/SV). */
  num: (n: number) => string;
  /** BCP-47 locale for dates/times: en-GB, fi-FI, sv-FI. */
  locale: string;
};

export const I18nContext = createContext<I18nCtx | null>(null);

export function useI18n(): I18nCtx {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n outside I18nProvider');
  return ctx;
}
